import React from 'react';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import styleFile from './Price.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { getPrice, formatCurrencyAmount, formatToSi } from '@synergycms_core/utils/utils';
import { Map } from 'immutable';
import { withContent } from '../../providers/translateProvider';

class Price extends React.PureComponent {
  static displayName = 'Price';
  render() {
    const { config, theme, content } = this.props,
      {
        innerStyle,
        currencies,
        langInfo,
        currentCurrencyCode,
        hotelCurrencyCode,
        hideDecimals = false,
        hideSymbol = false,
        forceHotelCurrency = false,
        forceSymbol = false,
        formatPrice = false
      } = config,
      currentCurrency = currencies.find(c => c.get('code') === currentCurrencyCode),
      hotelCurrency = currencies.find(c => c.get('code') === hotelCurrencyCode),
      finalCurrency = forceHotelCurrency ? hotelCurrency : currentCurrency;
    if (!finalCurrency) {
      return null;
    }

    let { amount } = config;

    if (!forceHotelCurrency && hotelCurrency && hotelCurrency.get('code') !== currentCurrency.get('code')) {
      amount = getPrice(amount, hotelCurrency.get('ratio'), currentCurrency.get('ratio'));
    }
    const symbolBefore = forceSymbol && finalCurrency.get('position');

    const symbol = hideSymbol ? '' : forceSymbol ? finalCurrency.get('symbol') : finalCurrency.get('code');
    const decimals = hideDecimals ? 0 : finalCurrency.get('decimals');
    const finalPrice = formatPrice ? formatToSi(amount, finalCurrency) : formatCurrencyAmount(currencies, currentCurrencyCode, finalCurrency, symbolBefore)(amount, symbol, decimals, symbolBefore);

    let textLabel = config.ariaLabel || '';

    if (textLabel && content) {
      textLabel = content.t(textLabel);
    }

    return (
      <span className={theme.styleGetter(innerStyle)} aria-label={textLabel + finalPrice} tabIndex={config.tabIndex} aria-hidden={config.ariaHidden}>
        {finalPrice}
      </span>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = (store, ownProps) => {
  return {
    currencies: store.getIn(['customer', 'currencies']),
    langInfo: store.getIn(['customer', 'lang_info']),
    currentCurrencyCode: store.getIn(['customer', 'current_currency']) || undefined,
    hotelCurrencyCode:
      ownProps.hotelCurrencyCode ||
      store.getIn(['hotels', store.getIn(['customer', 'current_hotel']), 'currency', 'code']) || // Monohotel
      (store.get('hotels').find((v, k) => Number.isFinite(+k)) || Map()).getIn(['currency', 'code']) // Multihotel
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'config',
    'amount',
    'currentCurrencyCode',
    'hotelCurrencyCode',
    'langInfo',
    'currencies',
    'hideDecimals',
    'hideSymbol',
    'forceHotelCurrency',
    'forceSymbol',
    'formatPrice',
    'tabIndex',
    'ariaLabel',
    'ariaHidden'
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(Price);
